// extracted by mini-css-extract-plugin
module.exports = {"pageBtn":"pager_pageBtn__zQ7pw","active":"pager_active__LtmAB","pageDots":"pager_pageDots__24vId"};